import MyPic from '../../assets/img/novan.jpg';

const Aboutpage = () => {
    return (
        <div className="About my-5 py-5">
            <div className="container">
                <div className="row pt-5">
                    <div className="col-md-8">
                        <h3 className="mb-4" >What is Land of Game?</h3>
                        <p>Land of game is a portfolio website about game database that using RAWG Public API. This website is just for practicing and not for commercial use.</p>
                        <p>
                        Here are some of tools and technologies that used in this project:
                        <ul>
                            <li>React JS</li>
                            <li>RAWG API</li>
                            <li>Axios</li>
                            <li>Bootstrap 5</li>
                        </ul>
                        </p>
                    </div>
                </div>
                <div className="row pt-5">
                    <div className="col-md-8">
                        <h3 className="mb-4">Developer</h3>
                        <div className="card mb-3 rounded-2 border-0">
                            <div className="row g-0">
                                <div className="col-md-4">
                                    <img className="img-fluid rounded-circle mx-auto d-block px-3 py-3" src={MyPic} alt="Novan Juanedi" />
                                </div>
                                <div className="col-md-8 text-center text-md-start">
                                    <div className="card-body py-5">
                                        <h5 className="card-title">Novan Junaedi</h5>
                                        <p className="card-text">Frontend web developer based in Bandung, Indonesia.</p>
                                        <a href="https://instagram.com/novanjunaedi" target="_blank" rel="noreferrer">
                                            <i className="fab fa-fw fa-instagram text-danger" />
                                        </a>
                                        <a href="https://facebook.com/novanjunaedi98" target="_blank" rel="noreferrer">
                                            <i className="fab fa-fw fa-facebook text-danger" />
                                        </a>
                                        <a href="https://twitter.com/novanjunaedi98" target="_blank" rel="noreferrer">
                                            <i className="fab fa-fw fa-twitter text-danger" />
                                        </a>
                                        <a href="https://github.com/novanjunaedi" target="_blank" rel="noreferrer">
                                            <i className="fab fa-fw fa-github text-danger" />
                                        </a>
                                        <a href="https://linkedin.com/in/novanjunaedi" target="_blank" rel="noreferrer">
                                            <i className="fab fa-fw fa-linkedin text-danger" />
                                        </a>
                                     </div>
                                     <div className="card-footer bg-white border-0">
                                        <a href="https://novanjunaedi.com" target="_blank" rel="noreferrer" className="card-link">
                                            <small className="text-muted"> novanjunaedi.com</small>
                                        </a>
                                     </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Aboutpage;
